import { jsPDF } from "jspdf";
import { fieldSvg, svgToPng } from "@/lib/pdf";
import { resolvePlayers } from "@/lib/geometry";

const HIT = { ground: "GRD", fly: "FLY", bunt: "BNT" };
const bases = (mask) => (mask ? ["1", "2", "3"].map((b, i) => (mask & (1 << i) ? b : "-")).join("") : "EMPTY");
const short = (p) => `${HIT[p.hit_type]} ${p.fielder} · ${p.outs} OUT · ${bases(p.runners)}`;
const throwText = (p) => (p.throws.length ? `Throw: ${[p.throws[0].src, ...p.throws.map((t) => t.dst)].join(" > ")}` : "No throw");

async function diagramCards(doc, plays, cfg, teamName) {
  const CW = 180;
  const CH = 182;
  const X0 = (792 - CW * 4) / 2;
  const Y0 = (612 - CH * 3) / 2;
  for (let i = 0; i < plays.length; i += 1) {
    if (i > 0 && i % 12 === 0) doc.addPage();
    const n = i % 12;
    const x = X0 + (n % 4) * CW;
    const y = Y0 + Math.floor(n / 4) * CH;
    const play = plays[i];
    doc.setLineDashPattern([3, 3], 0).setDrawColor(150).rect(x, y, CW, CH);
    const { svg } = fieldSvg(play, cfg, play.ball, false);
    doc.addImage(await svgToPng(svg, 720, 595), "JPEG", x + 6, y + 6, CW - 12, (CW - 12) * (1.19 / 1.44));
    doc.setFont("helvetica", "bold").setFontSize(9).setTextColor(15);
    doc.text(`${i + 1}. ${short(play)}`, x + 6, y + 157);
    doc.setFont("helvetica", "normal").setFontSize(8).text(throwText(play), x + 6, y + 169);
    doc.setFontSize(6).setTextColor(120).text(teamName.toUpperCase(), x + CW - 6, y + 177, { align: "right" });
  }
}

function positionPanels(doc, plays, cfg, teamName, pos) {
  const PW = 324;
  const PH = 198;
  const ROWS = 11;
  const X0 = (792 - PW * 2) / 2;
  const Y0 = (612 - PH * 3) / 2;
  const chunks = [];
  for (let i = 0; i < plays.length; i += ROWS) chunks.push(plays.slice(i, i + ROWS));
  chunks.forEach((chunk, c) => {
    if (c > 0 && c % 6 === 0) doc.addPage();
    const n = c % 6;
    const x = X0 + (n % 2) * PW;
    const y = Y0 + Math.floor(n / 2) * PH;
    doc.setLineDashPattern([3, 3], 0).setDrawColor(150).rect(x, y, PW, PH);
    doc.setLineDashPattern([], 0).setFillColor(15, 23, 42).rect(x, y, PW, 20, "F");
    doc.setFont("helvetica", "bold").setFontSize(10).setTextColor(255).text(`${teamName.toUpperCase()} · ${pos}`, x + 8, y + 14);
    chunk.forEach((play, r) => {
      const me = resolvePlayers(play, play.ball, cfg)[pos];
      const ry = y + 34 + r * 15;
      if (r % 2 === 0) doc.setFillColor(241, 245, 249).rect(x + 1, ry - 10, PW - 2, 15, "F");
      doc.setFont("helvetica", "bold").setFontSize(9).setTextColor(15).text(`${c * ROWS + r + 1}`, x + 8, ry);
      doc.setFont("helvetica", "normal").text(short(play), x + 24, ry);
      doc.setFont("helvetica", "bold").text(me.label, x + PW - 8, ry, { align: "right" });
    });
  });
}

export async function exportWristband(plays, cfg, teamName, pos) {
  const doc = new jsPDF({ unit: "pt", format: "letter", orientation: "landscape" });
  if (pos) positionPanels(doc, plays, cfg, teamName, pos);
  else await diagramCards(doc, plays, cfg, teamName);
  doc.save(`${teamName}-wristband${pos ? `-${pos}` : ""}.pdf`);
}
